import React, { useEffect } from "react";
import Visibility from "../utils/Visibility";
import CirclesMenu from "../MenusElements/CirclesMenu";
import Iterator from "../utils/Iterator";
import { Skeleton } from "../ui/skeleton";
import Spacer from "../Spacer";
import LoadingMenusProduct from "./LoadingMenusProduct";

function RenderAndLoadingMenuCilrcles({
  loading,
  menus,
  selectedMenu,
  handleSelectChange,
  children,
}: {
  loading: boolean;
  menus: any;
  selectedMenu: any;
  handleSelectChange: any;
  children: any;
}) {
  useEffect(() => {
    if (menus.length !== 0) {
      const activeElement = document.querySelector(".menu-active");
      if (activeElement) {
        activeElement.scrollIntoView({
          behavior: "smooth",
          inline: "center",
          block: "nearest",
        });
      }
    }
  }, [handleSelectChange, menus]);
  return (
    <div>
      <Visibility visible={!loading}>
        <div className={`bg-primary rounded-b-3xl p-3 pb-5`}>
          <CirclesMenu
            data={menus}
            selectedMenu={selectedMenu}
            onClickMenu={handleSelectChange}
          />
        </div>
        {children}
      </Visibility>
      <Visibility visible={loading}>
        <div className="flex-grow">
          <Skeleton className={`bg-opacity-80 rounded-b-3xl p-3 pb-5`}>
            <div className={`flex gap-3 p-3 pb-5 `}>
              <Iterator
                data={[1, 2, 3, 4, 5]}
                render={() => (
                  <Skeleton className={` w-16 h-16  rounded-full  `} />
                )}
              />
            </div>
          </Skeleton>
          <Spacer height={15} />
          <div className="flex flex-col gap-4 px-4">
            <Skeleton className={` w-full h-11 rounded-full   `} />

            <div className={`flex gap-3 `}>
              <Iterator
                data={[1, 2, 3]}
                render={() => (
                  <div>
                    <Skeleton className={` w-20 h-12 rounded-md   `} />
                  </div>
                )}
              />
            </div>
            <div>
              <div className="flex gap-5 py-2  ">
                <Skeleton className={` w-8 h-8 rounded-md   `} />
                <Skeleton className={` w-8 h-8 rounded-md   `} />
              </div>
              <Spacer height={30} />
              <LoadingMenusProduct displayWaygrid={true} />
            </div>
          </div>
        </div>
      </Visibility>
    </div>
  );
}

export default RenderAndLoadingMenuCilrcles;
